import React, { useState, useEffect, useRef } from 'react';
import './Notifications.css';

const Notifications = ({ isOpen, onClose }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      avatar: 'https://randomuser.me/api/portraits/women/42.jpg',
      name: 'Sarah Johnson',
      text: 'assigned you a new task in E-commerce Project',
      time: '2 minutes ago',
      type: 'task',
      isUnread: true,
      actions: ['markRead']
    },
    {
      id: 2,
      avatar: null,
      icon: 'fas fa-exclamation-triangle',
      iconType: 'system',
      name: 'System Alert',
      text: 'Your project deadline is approaching in 2 days',
      time: '1 hour ago',
      type: 'deadline',
      isUnread: true,
      actions: ['markRead']
    },
    {
      id: 3,
      avatar: 'https://randomuser.me/api/portraits/men/35.jpg',
      name: 'Mike Chen',
      text: 'commented on your task: "Great progress on the homepage design!"',
      time: '3 hours ago',
      type: 'comment',
      isUnread: false,
      actions: ['reply']
    },
    {
      id: 4,
      avatar: null,
      icon: 'fas fa-check-circle',
      iconType: 'success',
      name: null,
      text: 'Task "Design Homepage Layout" has been completed successfully',
      time: '1 day ago',
      type: 'success',
      isUnread: false,
      actions: []
    },
    {
      id: 5,
      avatar: 'https://randomuser.me/api/portraits/women/28.jpg',
      name: 'Emma Wilson',
      text: 'invited you to join the Marketing Campaign project',
      time: '2 days ago',
      type: 'invite',
      isUnread: false,
      actions: ['accept', 'decline']
    },
    {
      id: 6,
      avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
      name: 'David Rodriguez',
      text: 'mentioned you in a comment: "@John, could you review the latest design mockups?"',
      time: '3 days ago',
      type: 'mention',
      isUnread: true,
      actions: ['reply']
    },
    {
      id: 7,
      avatar: null,
      icon: 'fas fa-sync-alt',
      iconType: 'system',
      name: 'System Update',
      text: 'New features have been added to the project management dashboard',
      time: '3 days ago',
      type: 'update',
      isUnread: false,
      actions: []
    },
    {
      id: 8,
      avatar: 'https://randomuser.me/api/portraits/women/52.jpg',
      name: 'Lisa Park',
      text: 'shared a new file "Requirements Document v2.pdf" with your team',
      time: '4 days ago',
      type: 'task',
      isUnread: false,
      actions: ['view']
    },
    {
      id: 9,
      avatar: null,
      icon: 'fas fa-trophy',
      iconType: 'success',
      name: 'Milestone Achieved',
      text: 'You\'ve completed 25 tasks this month! Keep up the great work.',
      time: '5 days ago',
      type: 'success',
      isUnread: false,
      actions: []
    },
    {
      id: 10,
      avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
      name: 'Alex Thompson',
      text: 'requested approval for the Budget Allocation document',
      time: '1 week ago',
      type: 'approval',
      isUnread: true,
      actions: ['accept', 'decline']
    }
  ]);

  const notificationsRef = useRef(null);

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  // Handle body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Filter notifications based on active filter
  const filteredNotifications = notifications.filter(notification => {
    if (activeFilter === 'all') return true;
    if (activeFilter === 'unread') return notification.isUnread;
    if (activeFilter === 'mentions') return notification.text.includes('@');
    return true;
  });

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  const handleMarkAsRead = (notificationId) => {
    setNotifications(prev => 
      prev.map(notification => 
        notification.id === notificationId 
          ? { ...notification, isUnread: false }
          : notification
      )
    );
  };

  const handleMarkAllAsRead = () => {
    setNotifications(prev => 
      prev.map(notification => ({ ...notification, isUnread: false }))
    );
  };

  const handleAcceptInvitation = (notificationId) => {
    setNotifications(prev => 
      prev.map(notification => 
        notification.id === notificationId 
          ? { ...notification, isUnread: false, actions: [], status: 'accepted' }
          : notification
      )
    );
  };

  const handleDeclineInvitation = (notificationId) => {
    setNotifications(prev => 
      prev.map(notification => 
        notification.id === notificationId 
          ? { ...notification, isUnread: false, actions: [], status: 'declined' }
          : notification
      )
    );
  };

  const getActionButton = (action, notificationId) => {
    switch (action) {
      case 'markRead':
        return (
          <button 
            className="action-btn" 
            title="Mark as read"
            onClick={(e) => {
              e.stopPropagation();
              handleMarkAsRead(notificationId);
            }}
          >
            <i className="fas fa-check"></i>
          </button>
        );
      case 'reply':
        return (
          <button 
            className="action-btn" 
            title="Reply"
            onClick={(e) => {
              e.stopPropagation();
              console.log('Reply to notification:', notificationId);
            }}
          >
            <i className="fas fa-reply"></i>
          </button>
        );
      case 'accept':
        return (
          <button 
            className="action-btn accept" 
            title="Accept"
            onClick={(e) => {
              e.stopPropagation();
              handleAcceptInvitation(notificationId);
            }}
          >
            <i className="fas fa-check"></i>
          </button>
        );
      case 'decline':
        return (
          <button 
            className="action-btn decline" 
            title="Decline"
            onClick={(e) => {
              e.stopPropagation();
              handleDeclineInvitation(notificationId);
            }}
          >
            <i className="fas fa-times"></i>
          </button>
        );
      case 'view':
        return (
          <button 
            className="action-btn" 
            title="View file"
            onClick={(e) => {
              e.stopPropagation();
              console.log('View file from notification:', notificationId);
            }}
          >
            <i className="fas fa-eye"></i>
          </button>
        );
      default:
        return null;
    }
  };

  const renderNotificationStatus = (notification) => {
    if (notification.status === 'accepted') {
      return <span style={{ color: 'var(--success-color)', fontSize: '0.75rem', fontWeight: '600' }}>Accepted</span>;
    }
    if (notification.status === 'declined') {
      return <span style={{ color: 'var(--danger-color)', fontSize: '0.75rem', fontWeight: '600' }}>Declined</span>;
    }
    return null;
  };

  if (!isOpen) return null;

  return (
    <div className={`notifications-offcanvas ${isOpen ? 'show' : ''}`}>
      <div className="offcanvas-overlay" onClick={onClose}></div>
      <div className="offcanvas-content" ref={notificationsRef}>
        <div className="offcanvas-header">
          <h3 className="offcanvas-title">
            <i className="fas fa-bell"></i>
            Notifications
          </h3>
          <button className="offcanvas-close" onClick={onClose} aria-label="Close notifications">
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="offcanvas-body">
          <div className="notification-filters">
            <button 
              className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => handleFilterChange('all')}
            >
              All
            </button>
            <button 
              className={`filter-btn ${activeFilter === 'unread' ? 'active' : ''}`}
              onClick={() => handleFilterChange('unread')}
            >
              Unread
            </button>
            <button 
              className={`filter-btn ${activeFilter === 'mentions' ? 'active' : ''}`}
              onClick={() => handleFilterChange('mentions')}
            >
              Mentions
            </button>
          </div>

          <div className="notifications-list">
            {filteredNotifications.map((notification) => (
              <div 
                key={notification.id} 
                className={`notification-card ${notification.isUnread ? 'unread' : ''}`}
              >
                <div className="notification-avatar">
                  {notification.avatar ? (
                    <img src={notification.avatar} alt={notification.name} />
                  ) : (
                    <div className={`avatar-icon ${notification.iconType}`}>
                      <i className={notification.icon}></i>
                    </div>
                  )}
                </div>
                <div className="notification-content">
                  <div className="notification-text">
                    {notification.name && <strong>{notification.name}</strong>} {notification.text}
                  </div>
                  <div className="notification-meta">
                    <span className="notification-time">{notification.time}</span>
                    <span className={`notification-type ${notification.type}`}>
                      {notification.type}
                    </span>
                  </div>
                </div>
                <div className="notification-actions">
                  {notification.status ? (
                    renderNotificationStatus(notification)
                  ) : (
                    notification.actions.map((action) => getActionButton(action, notification.id))
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="notifications-footer">
            <button className="btn-link" onClick={handleMarkAllAsRead}>
              Mark all as read
            </button>
            <button className="btn-link" onClick={() => console.log('View all notifications')}>
              View all notifications
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
